import React from "react";
import { Table } from "reactstrap";

import ScoringReportRow from "./row/ScoringReportRow";

const ScoringResultsTable = ({ scoringResultsReports }) => {
  const rows = scoringResultsReports.map((entry) => (
    <ScoringReportRow key={entry.id} entry={entry} />
  ));

  return (
    <React.Fragment>
      {scoringResultsReports.length ? (
        <Table
          className="scoring-results-report-table"
        >
          <thead className="thead-light">
            <tr>
              <th>Date</th>
              <th>Export label</th>
              <th>Scoring type</th>
              <th />
              <th />
            </tr>
          </thead>
          <tbody>{rows}</tbody>
        </Table>
      ) : (
        ""
      )}
    </React.Fragment>
  );
};

export default ScoringResultsTable;



// WEBPACK FOOTER //
// ./src/features/reports/pages/scoring-results-report-page/scoring-results-table/ScoringResultsTable.jsx